import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'appDynamicProviders',
  isDragable: false,
  canOpen: true,
  canEdit: false,
  canCreate: false,
  canRemove: true,
  createPath: routes.APP_DYNAMIC_NEW,
  editURL: routes.APP_PROVIDER_EDIT,
  emptyMessage: "You don't have V.T. Providers, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'providerImage',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Logo',
      helpText: 'Logo to identify the provider in the app.',
      placeholder: 'Poster URL...',
      canCreate: true,
      canEdit: true,
      fileType:['image/*']
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Title of virtual ticket provider.',
      default: '',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      canOrder: false,
    },
    {
      attributeName: 'uses',
      label: 'Uses',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      helpText: 'Number of uses per token.',
      width: '4rem',
      canEdit: true,
      canCreate: true,
      canFilter: false,
      canOrder: false,
    },
    {
      attributeName: 'purchaseDynamicProcessURL',
      label: 'Purchase URL',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The URL to start a purchase process by the end user.',
      canEdit: true,
      canCreate: true,
      canOrder: false,
    },
    {
      attributeName: 'tokensURL',
      label: 'Tokens',
      type: FormInputTypes.LINK,
      icon: IconType.LINK,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Link to open the tokens list.',
    },  
  ],
};
